import { useEffect, useRef, useState } from 'react';
import EventTypeCheckboxes from '../EventTypeCheckboxes.jsx';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import CompactEventTypeSelect from '../forms/CompactEventTypeSelect';
import { debounce } from '../../lib/Utils.js';
import {
    setAvailabilityGroupsQuery,
    setBookableResourcesQuery,
} from '../../lib/Queries';

const EventTypeSelection = ({
    types,
    resource,
    availabilityGroupId,
    isNewGroup,
    onSave,
}) => {
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [isDirty, setIsDirty] = useState(false);
    const eventTypeSelectRef = useRef();

    const { save, isSaving } = useBusinessPostApi(
        `/scheduling/availability/${resource.id}/event-types`,
    );

    useEffect(() => {
        setSelectedTypes(types);
    }, [availabilityGroupId, JSON.stringify(types)]);

    function doSave(types) {
        save({
            types: types,
            availabilityGroup: availabilityGroupId,
        }).then(result => {
            setIsDirty(false);
            eventTypeSelectRef.current?.close();

            setAvailabilityGroupsQuery(resource.id, result?.availabilityGroups);
            setBookableResourcesQuery(result?.bookableResources, true);

            onSave();
        });
    }

    return (
        <div>
            <div className="input-label mt-4">Event Types</div>
            <CompactEventTypeSelect
                ref={eventTypeSelectRef}
                value={selectedTypes}
                onChange={value => {
                    setSelectedTypes(value);
                    setIsDirty(true);
                }}
                containerClassName="!border-gray-200"
                initialOpen={isNewGroup}
                disableClasses={true}
            />
            {isDirty && (
                <button
                    className="btn-save mt-2"
                    onClick={() => doSave(selectedTypes)}
                >
                    {isSaving ? 'Saving...' : 'Save Event Types'}
                </button>
            )}
        </div>
    );
};

export default EventTypeSelection;
